<div class="content-wrapper" id="bannerClose">
    <div class="page-header">
        <h4 class="page-titles">
            <span class="page-title-icons bg-gradient-primary text-white mr-2">
                <i class="mdi mdi-chart-line"></i>
            </span> ผลการสนับสนุนโครงการจัดรูปที่ดิน
        </h4>
    </div>


    <div class="col-12 grid-margin">
        <div class="card">
            <div class="row card-body">
                <div class="col-12">
                    <h4 class="text-center">
                        <u>สรุปการสนับสนุนเงินของกองทุนแยกตามปีงบประมาณ</u>
                    </h4>
                    <br>
                    <div echarts [options]="EChartOption1" class="demo-chart"></div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-12 grid-margin">
        <div class="card">
            <div class="row card-body">
                <div class="col-12">
                    <h4 class="text-center">
                        <u>สรุปสัดส่วนประเภทเงินของกองทุนจัดรูปที่ดิน</u>
                    </h4>
                    <br>
                    <div echarts [options]="EChartOption2" class="demo-chart"></div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-12 grid-margin">
        <div class="card">

            <div class="card-body">
                <div class="col-12">
                    <h4 class="text-center">
                        <u>รายงานความก้าวหน้าการติดตามโครงการจัดรูปที่ดินฯที่ได้รับการสนับสนุนด้านการเงินจากกองทุน</u>
                    </h4><br>
                    <div class="table-responsive" *ngIf="!pdf">
                        <table class="table table-bordered table-hover"
                            style="cursor: context-menu; border-top: 1px solid #ebedf2;">
                            <thead>
                                <tr class="text-center">
                                    <th style="font-weight: 500; vertical-align: middle;" rowspan="2"> ปีงบประมาณ </th>
                                    <th style="font-weight: 500;" colspan="4"> รายงานความก้าวหน้า </th>
                                </tr>
                                <tr class="text-center">
                                    <th style="font-weight: 500;"> ไตรมาสที่ 1 </th>
                                    <th style="font-weight: 500;"> ไตรมาสที่ 2 </th>
                                    <th style="font-weight: 500;"> ไตรมาสที่ 3 </th>
                                    <th style="font-weight: 500;"> ไตรมาสที่ 4 </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="text-center" *ngFor="let year of years">
                                    <td>
                                        {{year}}
                                    </td>
                                    <td class="click" *ngFor="let item of report_progress[year]"
                                        style="cursor: pointer;">
                                        <a href="https://ogc.mapedia.co.th/api/v1/lrfund/m_file/{{item.pdf_name}}" type="button"
                                            class="btn btn-inverse-primary btn-sm" target="_blank" *ngIf="item.id!=0"><i
                                                class="mdi mdi-file-pdf" style="font-size: 12px;"></i></a>

                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div *ngIf="pdf">
                        <div class="row">
                            <div class="col-6 text-left" style="cursor:context-menu;"> </div>
                            <div class="col-6 text-right">
                                <button type="button" class="btn btn-inverse-primary btn-sm"
                                    (click)="onSave()">ดาวน์โหลด</button>
                                <button type="button" class="btn btn-inverse-danger btn-sm" style="margin-left: 10px;"
                                    (click)="onBack()">ย้อนกลับ</button>
                            </div>
                        </div>
                        <pdf-viewer [src]="pdfSrc" [render-text]="true" style="display: block;"></pdf-viewer>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>